import { TableColumn } from '../../models';
import { ProgressBarCellComponent, ProgressBarCellProps } from './progress-bar.component';

export class ProgressBarColumn<I> extends TableColumn<I, ProgressBarCellProps> {
  readonly component = ProgressBarCellComponent;
}
